import "./CustomerDashboard.css";
import "../../App.css";
import "antd/dist/antd.css";
import { Table } from "antd";
import "./Sidebar.css";
import React from "react";
import { useEffect, useState } from "react";
import Popup from "reactjs-popup";
import "swiper/css";
import "swiper/css/pagination";
import { useStateValue } from "../../Component/StateProviders";
import { useNavigate } from "react-router-dom";
import { format } from "date-fns";
import toast from "react-hot-toast";
import {
  printInvoice,
  viewInvoice,
  getInvoiceUrl,
} from "../../utils/invoiceActions";
import { ClipLoader } from "react-spinners";
import { PAYMENT_GATEWAY_ENABLED } from "../../config/payment";

// prescriptions table start

const Prescribecolumns = [
  {
    title: " Name",
    dataIndex: "Name",
    key: "name",
  },
  {
    title: "Date",
    dataIndex: "Date",
    key: "date",
    render: (text) => {
      const formattedDate = format(new Date(text), "dd-MM-yyyy");
      return (
        <>
          <div className="client_dashboard_table_appdate_date">
            {formattedDate}
          </div>
        </>
      );
    },
  },

  {
    title: "Attachment",
    dataIndex: "Attachment",
    key: "Attachment",
    render: (text) => (
      <>
        <a href={text} target="_blank">
          {" "}
          <button className="client_dashboard_table_view_btn">
            <i class="fa-regular fa-eye"></i> View
          </button>
        </a>
      </>
    ),
  },
];

// prescriptions table end

// medical records table start

// medical records table end

// billing table start

const BillingColumn = [
  {
    title: "Invoice No",
    dataIndex: "Invoice",
    key: "InvoiceNo",
  },
  {
    title: "Amount",
    dataIndex: "Amount",
    key: "Amount",
  },
  {
    title: "Paid On",
    dataIndex: "Paidon",
    key: "PaidOn",
    render: (text) => {
      const formattedDate = format(new Date(text), "dd-MM-yyyy");
      return (
        <>
          <div className="client_dashboard_table_appdate_date">
            {formattedDate}
          </div>
        </>
      );
    },
  },
  {
    title: "Actions",
    key: "Attachment",
    dataIndex: "Attachment",
    render: (text) => {
      const invoiceUrl = getInvoiceUrl(text);
      return (
        <div style={{ whiteSpace: "nowrap" }}>
          <button
            type="button"
            className="client_dashboard_table_print_btn me-2"
            disabled={!invoiceUrl}
            onClick={() => printInvoice(invoiceUrl)}
          >
            <i className="fa-solid fa-print" /> Print
          </button>
          <button
            type="button"
            className="client_dashboard_table_view_btn"
            disabled={!invoiceUrl}
            onClick={() => viewInvoice(invoiceUrl)}
          >
            <i className="fa-regular fa-eye" /> View
          </button>
        </div>
      );
    },
  },
];

// billing table end

function CustomerDashboard() {
  //     ######################### Notification Section ###########################

  const [anchorEl, setAnchorEl] = useState(null);

  // const [AllMsg,setAllMsg] = useState([])
  const [GroupName, setGroupName] = useState("");
  // const [unreadcount,setunreadcount] = useState("")

  const [chatSocket, setChatSocket] = useState(null);
  const [webSocketInitialized, setWebSocketInitialized] = useState(false);

  useEffect(() => {
    if (!webSocketInitialized && GroupName !== "") {
      const socket = new WebSocket(
        window.WEBSOC + "ws/ClientDashboard/" + GroupName,
      );
      socket.onopen = () => {
        console.log("WebSocket connection opened");
        setWebSocketInitialized(true);
      };
      socket.onmessage = function (e) {
        let received_data_as_object = e["data"];
        // console.log(received_data_as_object)

        if (received_data_as_object.split("_")[0] === "Reload") {
          get_appointment();
        }
        //   const data = JSON.parse(e.data);
        // setChatLog((prevChatLog) => prevChatLog + e.data + '\n');
      };

      socket.onclose = function (e) {
        console.error("Chat socket closed unexpectedly");
        setWebSocketInitialized(false);
      };
      setChatSocket(socket);
      // return () => {
      //     socket.close();
      // };
    }
  }, [GroupName]);

  const Medicalcolumn = [
    {
      title: "Record ID",
      dataIndex: "id",
      key: "ID",
    },
    {
      title: "Date",
      dataIndex: "Date",
      key: "Date",
      render: (text) => {
        const formattedDate = format(new Date(text), "dd-MM-yyyy");
        return (
          <>
            <div className="client_dashboard_table_appdate_date">
              {formattedDate}
            </div>
          </>
        );
      },
    },
    {
      title: "Title Name",
      dataIndex: "TitleName",
      key: "TitleName",
    },
    {
      title: "Remarks",
      dataIndex: "Symptoms",
      key: "Description",
    },
    {
      title: "Attachment",
      dataIndex: "Attachment",
      key: "Attachment",
      render: (text) => (
        <>
          <a href={text} target="_blank">
            {" "}
            <button className="client_dashboard_table_view_btn">
              <i class="fa-regular fa-eye"></i> View
            </button>
          </a>
        </>
      ),
    },
    {
      title: "Uploaded By",
      dataIndex: "CreateBy",
      key: "Created",
      render: (text) => (
        <>
          <div>{text === "User" ? "You" : text}</div>
        </>
      ),
    },
    {
      title: "Actions",
      dataIndex: "Actions",
      key: "Actions",
      render: (text, record, index) => (
        <>
          <i
            class="fa-solid fa-trash-can"
            style={{ color: "#e11f28" }}
            onClick={() => {
              delete_medicalrecord(index, record.id);
            }}
          ></i>
        </>
      ),
    },
  ];

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 5,
    pageSizeOptions: ["5", "10", "20", "50", "100"],
    showSizeChanger: true,
  });

  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };

  const Appointmentcolumns = [
    {
      title: "Appt Date",
      dataIndex: "Date",
      key: "age",
      render: (text, record) => {
        const formattedDate = format(new Date(text), "dd-MM-yyyy");
        return (
          <>
            <div className="client_dashboard_table_appdate_date">
              {formattedDate}
            </div>
            <div className="client_dashboard_table_appdate_time">
              {record["Slot"]}
            </div>
          </>
        );
      },
    },
    {
      title: "Booking Date",
      dataIndex: "BookingDate",
      key: "address",
      render: (text) => {
        const formattedDate = format(new Date(text), "dd-MM-yyyy");
        return (
          <>
            <div className="client_dashboard_table_appdate_date">
              {formattedDate}
            </div>
          </>
        );
      },
    },
    {
      title: "Package",
      dataIndex: "Purpose",
      key: "Package",
    },
    {
      title: "Amount",
      dataIndex: "Amount",
      key: "address",
    },
    {
      title: "Status",
      dataIndex: "Status",
      key: "Status",
      render: (text, record) => (
        <>
          {text === 0 ? (
            <button className="client_dashboard_table_pending_btn">
              Pending Approval
            </button>
          ) : text === -1 ? (
            <button
              className="client_dashboard_table_reject_btn"
              onClick={() => {
                navigate("/booking");
              }}
            >
              Reschedule
            </button>
          ) : text === 1 || text === 2 ? (
            <button className="client_dashboard_table_confirm_btn" disabled>
              Completed
            </button>
          ) : null}
        </>
      ),
    },
    {
      title: "Bill",
      key: "Status",
      dataIndex: "Status",
      render: (text, record) => (
        <>
          {text === -1 ? (
            <button className="client_dashboard_table_reject_btn" disabled>
              N/A
            </button>
          ) : text === 0 ? (
            <button className="client_dashboard_table_pending_btn" disabled>
              N/A
            </button>
          ) : text === 1 || text === 2 ? (
            <button className="client_dashboard_table_confirm_btn" disabled>
              {PAYMENT_GATEWAY_ENABLED ? "Paid" : "Completed"}
            </button>
          ) : null}

          {/* ========== PAYMENT GATEWAY (Razorpay) — set PAYMENT_GATEWAY_ENABLED=true in config/payment.js and uncomment below ==========
          {text === 1 ? <button className='client_dashboard_table_pending_btn'
                onClick={() => {
                  var Url = window.API_PREFIX + 'booking/payfees'
                  fetch(Url, {
                    method: 'POST',
                    headers: { 'Content-type': 'application/json' },
                    body: JSON.stringify({
                        Token: localStorage.getItem('DToken'),
                        BookingId: record.BookingId,
                        Amount: record.Amount
                      }),
                  }).then(resp => resp.json()).then(data => {
                    if (data['status'] === "1") {
                      const options = {
                        key: data['key'],
                        amount: Number(record.Amount) * 100,
                        order_id: data['Payment_id'],
                        name: "Raive",
                        description: 'Thank you for payment',
                        handler: function (response) {
                          var Url = window.API_PREFIX + 'booking/verify_payment'
                          fetch(Url, {
                            method: 'POST',
                            headers: { 'Content-type': 'application/json' },
                            body: JSON.stringify({
                                Token: localStorage.getItem("DToken"),
                                razorpay_order_id: response.razorpay_order_id,
                                razorpay_payment_id: response.razorpay_payment_id,
                                razorpay_signature: response.razorpay_signature,
                                BookingId: record.BookingId,
                              }),
                          }).then(resp => resp.json()).then(Revdata => {
                            if (Revdata['status'] == "1") {
                              getbilling()
                              setDashboardOption([false, false, false, true])
                            }
                          })
                        },
                        prefill: { name: "", email: "", phone_number: "" }
                      };
                      const paymentObject = new window.Razorpay(options)
                      paymentObject.open()
                    }
                  })
                }}
              >Pay Amount</button> : null}
          ========== END PAYMENT GATEWAY ========== */}
        </>
      ),
    },
  ];

  function getprescription() {
    var Url = window.API_PREFIX + "admin/view_prescription";
    fetch(Url, {
      method: "POST",
      headers: {
        "Content-type": "application/json",
      },
      body: JSON.stringify({
        Token: localStorage.getItem("DToken"),
      }),
    })
      .then((resp) => resp.json())
      .then((data) => {
        console.log(data);
        if (data["status"] === "1") {
          setuserPrescribeData([...data["data"]]);
        }
      });
  }

  function getmedicalrecord() {
    var Url = window.API_PREFIX + "patient/view_medicalrecords";
    fetch(Url, {
      method: "POST",
      headers: {
        "Content-type": "application/json",
      },
      body: JSON.stringify({
        Token: localStorage.getItem("DToken"),
      }),
    })
      .then((resp) => resp.json())
      .then((data) => {
        console.log(data);
        if (data["status"] === "1") {
          setuserMedicalData([...data["records"]]);
        }
      });
  }

  function getbilling() {
    var Url = window.API_PREFIX + "patient/billingpatientwise";
    fetch(Url, {
      method: "POST",
      headers: {
        "Content-type": "application/json",
      },
      body: JSON.stringify({
        Token: localStorage.getItem("DToken"),
      }),
    })
      .then((resp) => resp.json())
      .then((data) => {
        console.log(data);
        if (data["status"] === "1") {
          setuserBillingData([...data["Bill"]]);
        }
      });
  }

  const addmedicalrecordpopup = {
    borderRadius: "10px",
    backgroundColor: "white",
    // boxshadow: "1 1 20px rgba(255, 255, 255, 0.4)",
    borderradius: "5px",
    padding: "0px",
    width: "100%",
    height: "max-content",
    margin: "20px 450px",
  };
  const [{ IsRegister }, dispatch] = useStateValue();
  const [userAppointmentData, setuserAppointmentData] = useState([]);
  const [userPrescribeData, setuserPrescribeData] = useState([]);
  const [userMedicalData, setuserMedicalData] = useState([]);
  const [addMedicalRecord, setAddMedicalRecord] = useState(false);
  const [TitleName, setTitleName] = useState();
  const [isRequiredTitleName, setIsRequiredTitleName] = useState(true);
  const [HospitalName, setHospitalName] = useState();
  const [isRequiredHospitalName, setIsRequiredHospitalName] = useState(true);
  const [Symptoms, setSymptoms] = useState();
  const [isRequiredSymptoms, setIsRequiredSymptoms] = useState(true);
  const [RecordDate, setRecordDate] = useState("");
  const [MedicalRecord, setMedicalRecord] = useState();
  const [isRequiredMedicalRecord, setIsRequiredMedicalRecord] = useState(true);

  const [userBillingData, setuserBillingData] = useState([]);
  const [userData, setuserData] = useState({});

  function get_appointment() {
    var Url = window.API_PREFIX + "patient/userwiseappointment";
    fetch(Url, {
      method: "POST",
      headers: {
        "Content-type": "application/json",
      },
      body: JSON.stringify({
        Token: localStorage.getItem("DToken"),
      }),
    })
      .then((resp) => resp.json())
      .then((data) => {
        console.log(data);
        if (data["status"] === "1") {
          setuserAppointmentData([...data["appointment"]]);
        }
      });
  }

  useEffect(() => {
    // dispatch({type:"Register"})

    get_appointment();
    var Url = window.API_PREFIX + "patient/view_profile";
    fetch(Url, {
      method: "POST",
      headers: {
        "Content-type": "application/json",
      },
      body: JSON.stringify({
        Token: localStorage.getItem("DToken"),
      }),
    })
      .then((resp) => resp.json())
      .then((data) => {
        console.log(data);
        if (data["status"] === "1") {
          setGroupName("User_" + data["id"] + "/");
          setuserData({ ...data });
        }
      });
  }, []);

  function delete_medicalrecord(Requestindex, id) {
    var Url = window.API_PREFIX + "admin/trash_delete_files";
    const index = userMedicalData.findIndex((records) => records.id === id);
    fetch(Url, {
      method: "POST",
      headers: {
        "Content-type": "application/json",
      },
      body: JSON.stringify({
        Token: localStorage.getItem("DToken"),
        Id: userMedicalData[index]["id"],
      }),
    })
      .then((resp) => resp.json())
      .then((data) => {
        console.log(data);
        if (data["status"] === "1") {
          getmedicalrecord();
        }
      });
  }

  const [DashboardOption, setDashboardOption] = useState([
    true,
    false,
    false,
    false,
    false,
  ]);

  const handleTextareaChange = (e) => {
    e.target.value !== ""
      ? setIsRequiredTitleName(false)
      : setIsRequiredTitleName(true);
    setTitleName(e.target.value);
  };

  const checkSubmitBtnDisable = () => {
    if (
      !isRequiredTitleName &&
      !isRequiredMedicalRecord &&
      !isRequiredSymptoms
    ) {
      return false;
    } else {
      return true;
    }
  };

  // responsive table start

  let navigate = useNavigate();

  // responsive table end

  const [loaderon, setloaderon] = useState(false);

  return (
    <>
      <main className="container-fuild mx-2">
        <div className="client_dashboard_main_division">
          <div class="client_bashboard_tab_division">
            <div
              className={
                DashboardOption[0]
                  ? "col client_bashboard_tabs_title_name_division_active"
                  : "col client_bashboard_tabs_title_name_division"
              }
              onClick={() => {
                var Url = window.API_PREFIX + "patient/userwiseappointment";
                fetch(Url, {
                  method: "POST",
                  headers: {
                    "Content-type": "application/json",
                  },
                  body: JSON.stringify({
                    Token: localStorage.getItem("DToken"),
                  }),
                })
                  .then((resp) => resp.json())
                  .then((data) => {
                    console.log(data);
                    if (data["status"] === "1") {
                      setuserAppointmentData([...data["appointment"]]);
                    }
                  });
                setDashboardOption([true, false, false, false]);
              }}
            >
              <div class="client_bashboard_tabs_title_name">Appointments</div>
            </div>
            <div
              className={
                DashboardOption[1]
                  ? "col client_bashboard_tabs_title_name_division_active"
                  : "col client_bashboard_tabs_title_name_division"
              }
              onClick={() => {
                getprescription();
                setDashboardOption([false, true, false, false]);
              }}
            >
              <div class="client_bashboard_tabs_title_name">Framework</div>
            </div>
            <div
              className={
                DashboardOption[2]
                  ? "col client_bashboard_tabs_title_name_division_active"
                  : "col client_bashboard_tabs_title_name_division"
              }
              onClick={() => {
                getmedicalrecord();

                setDashboardOption([false, false, true, false]);
              }}
            >
              <div class="client_bashboard_tabs_title_name">Files</div>
            </div>
            <div
              className={
                DashboardOption[3]
                  ? "col client_bashboard_tabs_title_name_division_active"
                  : "col client_bashboard_tabs_title_name_division"
              }
              onClick={() => {
                getbilling();

                setDashboardOption([false, false, false, true]);
              }}
            >
              <div class="client_bashboard_tabs_title_name">Billing</div>
            </div>
          </div>

          {DashboardOption[0] ? (
            <div className="client_dashboard_table_division">
              <Table
                columns={Appointmentcolumns}
                dataSource={userAppointmentData}
                pagination={pagination}
                onChange={handleTableChange}
              />
            </div>
          ) : DashboardOption[1] ? (
            <div className="client_dashboard_table_division">
              <Table
                columns={Prescribecolumns}
                dataSource={userPrescribeData}
                pagination={pagination}
                onChange={handleTableChange}
              />
            </div>
          ) : DashboardOption[2] ? (
            <>
              <div
                className="client_medicalrecords_add_records_section"
                onClick={() => {
                  setAddMedicalRecord(true);
                }}
              >
                <button
                  type="button"
                  className=" client_medical_records_add_records_button btn"
                >
                  <i class="fa-solid fa-plus me-2"></i>Add Files
                </button>
                {/* This css is in client Medical record */}
              </div>
              <div className="client_dashboard_table_division">
                <Table
                  columns={Medicalcolumn}
                  dataSource={userMedicalData}
                  pagination={pagination}
                  onChange={handleTableChange}
                />
              </div>
            </>
          ) : (
            <div className="client_dashboard_table_division">
              <Table
                columns={BillingColumn}
                dataSource={userBillingData}
                pagination={pagination}
                onChange={handleTableChange}
              />
            </div>
          )}
        </div>

        <Popup
          contentStyle={addmedicalrecordpopup}
          modal
          open={addMedicalRecord}
          onClose={() => {
            setAddMedicalRecord(false);
          }}
        >
          <div className="Add_medical_records_popup_div">
            <div className="add_medical_records_popuop_header">
              <h5 className="add_medical_records_records_title">Add Files</h5>
              <i
                onClick={() => {
                  setAddMedicalRecord(false);
                }}
                class=" add_medical_records_popuop_colse_button fa-solid fa-xmark"
              ></i>
            </div>
            <div className="add_medical_records_popup_body">
              <div className="popup_body_div_two">
                <div className="popup_body_name_client_section row">
                  <div className="col-12 col-md-6">
                    <p className="popup_body_name_title d-flex">
                      Title Name
                      <div className="required_feild ms-2">(* required) </div>
                    </p>
                    <input
                      type="text"
                      name="description"
                      class="addmedical_pop_text_feild form-control"
                      placeholder="Enter Title Name"
                      value={TitleName}
                      onChange={handleTextareaChange}
                      required
                    />
                  </div>
                </div>
                <br></br>

                <div>
                  <p className="popup_body_upload_title d-flex">
                    Upload
                    <div className="required_feild ms-2">(* required) </div>
                  </p>
                  <div class="  input-group">
                    <input
                      class=" form-control"
                      id="inputGroupFile02"
                      style={{ cursor: "pointer" }}
                      type="file"
                      name="myImage"
                      // accept="application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint, text/plain, application/pdf, image/*,*/*"
                      // onChange={(event) => {
                      //   event.target.files.length > 0 ? setIsRequiredMedicalRecord(false) : setIsRequiredMedicalRecord(true)
                      //   setMedicalRecord(event.target.files[0]);

                      // }}
                      onChange={(event) => {
                        const file = event.target.files[0];

                        if (file) {
                          // Check if file size is less than 20MB (20 * 1024 * 1024 bytes)
                          if (file.size < 20 * 1024 * 1024) {
                            setIsRequiredMedicalRecord(false);
                            setMedicalRecord(file);
                          } else {
                            // Show an alert or handle the file size error
                            alert("File size must be less than 20MB");
                            // Optionally, you can clear the file input
                            event.target.value = null;
                          }
                        } else {
                          setIsRequiredMedicalRecord(true);
                        }
                      }}
                      required
                    />
                    <label class="input-group-text" for="inputGroupFile02">
                      Upload
                    </label>
                  </div>
                </div>
                <br></br>
                <div>
                  <p className="popup_body_symptoms_title d-flex">
                    Remarks
                    <div className="required_feild ms-2">(* required) </div>
                  </p>
                  <input
                    type="text"
                    name="description"
                    class=" addmedical_pop_text_feild form-control"
                    placeholder=""
                    onChange={(e) => {
                      e.target.value !== ""
                        ? setIsRequiredSymptoms(false)
                        : setIsRequiredSymptoms(true);
                      setSymptoms(e.target.value);
                    }}
                    required
                  />
                </div>
                <br></br>
                <div className="text-center">
                  {loaderon ? (
                    <ClipLoader />
                  ) : (
                    <button
                      type="button"
                      className="popup_submit_button btn"
                      disabled={checkSubmitBtnDisable()}
                      onClick={() => {
                        var Url =
                          window.API_PREFIX + "patient/add_medicalrecords";
                        setloaderon(true);

                        var uploadData = new FormData();
                        uploadData.append(
                          "Token",
                          localStorage.getItem("DToken"),
                        );
                        uploadData.append("TitleName", TitleName);
                        // uploadData.append("HospitalName", HospitalName);
                        uploadData.append("Symptoms", Symptoms);
                        uploadData.append("RecordDate", RecordDate);
                        uploadData.append("Attachment", MedicalRecord);
                        fetch(Url, {
                          method: "POST",
                          // headers: {
                          //     'Content-type': 'application/json',
                          // },
                          body: uploadData,
                        })
                          .then((resp) => resp.json())
                          .then((data) => {
                            console.log(data);
                            if (data["status"] === "1") {
                              toast.success("Files Added");
                              getmedicalrecord();
                              setTitleName("");
                              setloaderon(false);
                              setAddMedicalRecord(false);
                            }
                          });
                      }}
                    >
                      Submit
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Popup>
      </main>
      {/* maintag-end */}
    </>
  );
}
export default CustomerDashboard;
